const UPCOMING_REVIEW_ROLES = Object.freeze({
  COACH: 'coach',
  PARTICIPANT: 'participant',
  ALL: 'all',
});
export default UPCOMING_REVIEW_ROLES;
